export const tokenManager = {
  initToken() {
    const params = new URLSearchParams(window.location.search);
    const tokenFromUrl = params.get('token');
    if (tokenFromUrl) {
      const existing = JSON.parse(localStorage.getItem('appParams') || '{}');
      localStorage.setItem('appParams', JSON.stringify({ ...existing, token: tokenFromUrl }));
    }
    return this.getToken();
  },
  getToken() {
    try {
      const params = JSON.parse(localStorage.getItem('appParams'));
      return params?.token || '';
    } catch (error) {
      console.error('Error getting token:', error);
      return '';
    }
  },
};


